const notFoundContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  justifyContent: 'center',
  fontFamily: 'arial, sans-serif',
};

const imageStyle = {
  width: '25%',
  minWidth: '20rem',
};

const errorCode = {
  margin: '0',
  fontSize: '9rem',
  color: '#c2c2c2',
};

const pageNotFoundMessage = {
  margin: '0',
  fontSize: '2.5rem',
  color: '#575656',
};

const errorMessage = {
  fontSize: '1.2rem',
  color: '#575656',
};

export default {
  notFoundContainer,
  imageStyle,
  errorCode,
  pageNotFoundMessage,
  errorMessage,
};
